module.exports = __webpack_public_path__ + "img/page-remaining-days.5293b1f1.png";